<app-table
  [actionColumnWidth]="editable ? 300 : 200"
  [columns]="columns"
  [editable]="editable"
  [loading]="loading"
  [value]="value">
  <ng-template
    (onClick)="showDetail($event.row)"
    [displayIf]="'id'"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>
</app-table>
